import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export default function ReturnToLandingPageButton() {
  function getLandingPageUrl(location: Location) {
    const appUrlLookup: { [key: string]: string } = {
      "localhost": "http://localhost:5000/",
      "pfabankui-n.app.cloud.gov":
        "https://pfabankfindui-n.app.cloud.gov/bankfind-suite",
      "pfabankui-d.app.cloud.gov":
        "https://pfabankfindui-d.app.cloud.gov/bankfind-suite",
      "pfabankui-s.app.cloud.gov":
        "https://pfabankfindui-s.app.cloud.gov/bankfind-suite",
      "pfabankui-q.app.cloud.gov":
        "https://pfabankfindui-q.app.cloud.gov/bankfind-suite",
      "pfabankui.app.cloud.gov": "https://banks.data.fdic.gov/bankfind-suite",
      "banks-n.data.fdic.gov":
        "https://pfabankfindui-n.app.cloud.gov/bankfind-suite",
      "banks-d.data.fdic.gov":
        "https://pfabankfindui-d.app.cloud.gov/bankfind-suite",
      "banks-s.data.fdic.gov":
        "https://pfabankfindui-s.app.cloud.gov/bankfind-suite",
      "banks-q.data.fdic.gov":
        "https://pfabankfindui-q.app.cloud.gov/bankfind-suite",
      "banks.data.fdic.gov": "https://banks.data.fdic.gov/bankfind-suite",
    };
    return appUrlLookup[location.hostname];
  }

  return (
    <a href={getLandingPageUrl(window.location)}>
      <button className="return-to-landing-page-button">
        <FontAwesomeIcon
          className="return-to-landing-page-button-icon"
          icon="angle-left"
        />{" "}
        &nbsp;
        <FontAwesomeIcon
          className="return-to-landing-page-button-icon"
          icon="university"
        />{" "}
        &nbsp;
        <span className="return-to-landing-page-button-label">
          {" "}
          BankFind Suite Home
        </span>
      </button>
    </a>
  );
}
